import api from '~config/api';

// The login runs synchronously against ClaveÚnica through kayak and the scraper,
// which can take several seconds; kayak itself stops waiting at ~29s.
const TIMEOUT = {
  timeout: 35000
};

export const login = values => api.post('/scrapers/chileatiende_login', values, TIMEOUT);

export const verify = values => api.post('/scrapers/chileatiende_verify', values, TIMEOUT);
